import axios from "axios";

export const contactApi = async (from, data = {}) => {
    try {
        const response = await axios.post(`/api/contact/${from}`, data);
        return response.data;
    } catch (e) {
        console.error(e);
    }
};
